import { PlayButton } from '@audio-network/componentlibrary'
import { usePlayer } from '@audio-network/player'
import { useTranslation } from 'next-i18next'

import styles from './TrackPlayback.module.css'
import { TrackPlaybackProps } from './TrackPlayback.types'

const TrackPlayback = ({ source, track }: TrackPlaybackProps): JSX.Element => {
	const { currentTrack, togglePlay, isPlaying } = usePlayer()
	const { t } = useTranslation(['app'])

	const isCurrentTrackPlaying = isPlaying && currentTrack?.id === track.id

	const playLabel = `${
		isCurrentTrackPlaying ? t('player-pause') : t('player-play')
	} ${track.title}`

	return (
		<PlayButton
			aria-label={playLabel}
			className={styles.playback}
			isPlaying={isCurrentTrackPlaying}
			onClick={() => togglePlay(track, { source })}
			size="S"
		/>
	)
}

export default TrackPlayback
